import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ScrollText, MessageSquareQuote, Plus, Minus } from "lucide-react";
import api from "@/lib/api";
import { useAssist, ScriptPanel } from "@/components/callcenter/CallAssist";
import { Rebuttals } from "@/components/callcenter/DialerTools";
import { useAuth } from "@/context/AuthContext";

export default function CallCenterPopout() {
  const { panel } = useParams();
  const { user } = useAuth();
  const [s, setS] = useState({ target: null, name: "", live: false, scriptId: "" });
  const [scripts, setScripts] = useState([]);
  const [zoom, setZoom] = useState(1);
  useEffect(() => {
    const ch = new BroadcastChannel("cc-sync");
    ch.onmessage = (e) => { if (e.data && e.data !== "hello" && e.data.from !== "popout") setS(e.data); };
    ch.postMessage("hello");
    window._ccCh = ch;
    return () => ch.close();
  }, []);
  useEffect(() => { api.get("/api/callcenter/scripts").then(r => setScripts(r.data)).catch(() => {}); document.title = panel === "rebuttals" ? "Rebuttals — Call Center" : "Call script — Call Center"; }, [panel]);
  const assist = useAssist(s.target, 0, s.scriptId);
  const pick = (id) => { setS({ ...s, scriptId: id }); window._ccCh?.postMessage({ from: "popout", scriptId: id }); };
  const Icon = panel === "rebuttals" ? MessageSquareQuote : ScrollText;
  return (
    <div className="min-h-screen bg-slate-50 p-4" data-testid={`cc-popout-${panel}`}>
      <div className="flex items-center gap-2 mb-3">
        <Icon className="w-5 h-5 text-blue-600" /><h1 className="font-extrabold text-slate-900">{panel === "rebuttals" ? "Rebuttals" : "Call script"}</h1>
        <span className={`text-xs px-2 py-0.5 rounded-full ${s.live ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-600"}`}>{s.live ? "Live call" : s.name ? "Next up" : "Waiting for the Call Center tab"}</span>
        <span className="ml-auto flex gap-1"><button onClick={() => setZoom(z => Math.max(0.8, z - 0.15))} className="p-1.5 bg-white border rounded-lg" data-testid="popout-zoom-out"><Minus className="w-4 h-4" /></button><button onClick={() => setZoom(z => Math.min(2, z + 0.15))} className="p-1.5 bg-white border rounded-lg" data-testid="popout-zoom-in"><Plus className="w-4 h-4" /></button></span>
      </div>
      <div className="bg-white border rounded-2xl p-4 shadow-sm" style={{ zoom }}>
        {panel === "rebuttals" ? <Rebuttals target={s.target} admin={false} items={assist?.rebuttals} big /> : <ScriptPanel assist={assist} live={s.live} name={s.name} scripts={scripts} scriptId={s.scriptId} onScript={pick} big />}
      </div>
      <p className="text-[11px] text-slate-400 mt-3 text-center">Drag this window to another screen. It follows the call in your Call Center tab{user ? "" : " — log in first"}.</p>
    </div>
  );
}
